import * as Yup from "yup";
import { Vocabulary } from "../Utils/Vocabulary";
import { PurchaseTypes } from "../Utils/autocompleteEnum";

export const schema = Yup.object().shape({
  tva_id: Yup.number().required(Vocabulary.required),
  tip_tva_r: Yup.object().required(Vocabulary.required),

  norma_poluare_id: Yup.number().required(Vocabulary.required),
  norma_poluare_r: Yup.object().required(Vocabulary.required),

  furnizor_id: Yup.number().required(Vocabulary.required),
  furnizor_r: Yup.object().required(Vocabulary.required),

  tip_vehicul_id: Yup.number().required(Vocabulary.required),
  tip_vehicul_r: Yup.object().required(Vocabulary.required),

  user_achizitie_id: Yup.number().required(Vocabulary.required),
  user_achizitie_r: Yup.object().required(Vocabulary.required),

  user_logistica_id: Yup.number().required(Vocabulary.required),
  user_logistica_r: Yup.object().required(Vocabulary.required),

  data_vanzare: Yup.date()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .typeError(Vocabulary.invalidDate),

  data_receptie: Yup.date().when("tip_achizitie_r", (value: any, schema) => {
    if (value[0]?.nume == PurchaseTypes?.buyBack || value[0]?.nume == PurchaseTypes?.national) {
      return schema
        .required(Vocabulary.required)
        .typeError(Vocabulary.invalidDate);
    } else {
      return schema
        .nullable()
        .transform((curr, orig) => (orig === "" ? null : curr))
        .typeError(Vocabulary.invalidDate);
    }
  }),

  // data_receptie: Yup.date()
  //   .required(Vocabulary.required)
  //   .typeError(Vocabulary.required),

  data_achizitie: Yup.date()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .typeError(Vocabulary.invalidDate),

  brand_id: Yup.number().required(Vocabulary.required),
  brand_r: Yup.object().required(Vocabulary.required),

  model_id: Yup.number().required(Vocabulary.required),
  model_r: Yup.object().required(Vocabulary.required),

  locatie_administrativa_id: Yup.number().required(Vocabulary.required),
  locatie_administrativa_r: Yup.object().required(Vocabulary.required),

  vin: Yup.string()
    .required(Vocabulary.required)
    .min(13, Vocabulary.minLimit)
    .max(17, Vocabulary.maxLimit),

  tip_achizitie_id: Yup.number().required(Vocabulary.required),
  tip_achizitie_r: Yup.object().required(Vocabulary.required),

  firma_achizitie_id: Yup.number().required(Vocabulary.required),
  firma_achizitie_r: Yup.object().required(Vocabulary.required),

  tip_caroserie_id: Yup.number().required(Vocabulary.required),
  tip_caroserie_r: Yup.object().required(Vocabulary.required),

  culoare_id: Yup.number().required(Vocabulary.required),
  culoare_r: Yup.object().required(Vocabulary.required),

  retromobil: Yup.string(),

  optiuni_culoare_id: Yup.number().required(Vocabulary.required),
  optiune_culoare_r: Yup.object().required(Vocabulary.required),

  tara_origine_id: Yup.number().required(Vocabulary.required),
  tara_origine_r: Yup.object().required(Vocabulary.required),


  kilometri: Yup.mixed().nullable(),
  an_fabricatie: Yup.number().required(Vocabulary.required),
  nr_locuri: Yup.number().required(Vocabulary.required),
  numar_portiere: Yup.number().required(Vocabulary.required),
  variant: Yup.string().nullable(),

  // Additional vehicle specifications
  data_inmatriculare: Yup.mixed()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr)),

  tip_tractiune_r: Yup.object(),
  combustibil_r: Yup.object(),
  cutie_viteze_r: Yup.object(),
  capacitate_cilindrica: Yup.mixed(),
  putere_cp: Yup.mixed(),

  rar_completed: Yup.boolean().nullable(),
  rar_scheduled: Yup.boolean().nullable(),
  rar_scheduled_date: Yup.date()
    .nullable()
    .when("rar_scheduled", {
      is: true,
      then: (schema) =>
        schema.required(Vocabulary.required).typeError(Vocabulary.invalidDate),
      otherwise: (schema) =>
        schema
          .nullable()
          .transform((curr: any, orig: any) => (orig === "" ? null : curr))
          .typeError(Vocabulary.invalidDate),
    }),
  itp_valid_until: Yup.date()
    .nullable()
    .transform((curr: any, orig: any) => (orig === "" ? null : curr))
    .typeError(Vocabulary.invalidDate),
  rca_valid_until: Yup.date()
    .nullable()
    .transform((curr: any, orig: any) => (orig === "" ? null : curr))
    .typeError(Vocabulary.invalidDate),
});

export const AutocompleteSchema = Yup.object().shape({
  nume: Yup.string().required(Vocabulary.required),
});

export const AutocompleteSchemaForAddress = Yup.object().shape({});

export const AutocompleteSchemaForFirmaAchizitie = Yup.object().shape({
  nume_firma: Yup.string().required(Vocabulary.required),
});

export const AutocompleteSchemaForTipTVA = Yup.object().shape({
  // nume: Yup.string().required(Vocabulary.required),
  // valoare:Yup.string().required(Vocabulary.required)
});
export const AutocompleteSchemaforDrivers = Yup.object().shape({
  name: Yup.string().required(Vocabulary.required),
});

// Schema for VehicleInformationForm step - only validates fields in that form
export const vehicleInformationSchema = Yup.object().shape({
  // Required fields
  vin: Yup.string()
    .required(Vocabulary.required)
    .min(13, Vocabulary.minLimit)
    .max(17, Vocabulary.maxLimit),

  tip_vehicul_r: Yup.object().required(Vocabulary.required),
  brand_r: Yup.object().required(Vocabulary.required),
  model_r: Yup.object().required(Vocabulary.required),
  variant: Yup.string().nullable(),
  tip_caroserie_r: Yup.object().required(Vocabulary.required),
  an_fabricatie: Yup.number().required(Vocabulary.required),
  tara_origine_r: Yup.object().required(Vocabulary.required),
  norma_poluare_r: Yup.object().required(Vocabulary.required),
  culoare_r: Yup.object().required(Vocabulary.required),
  optiune_culoare_r: Yup.object().required(Vocabulary.required),
  tip_tractiune_r: Yup.object().required(Vocabulary.required),
  combustibil_r: Yup.object().required(Vocabulary.required),
  cutie_viteze_r: Yup.object().required(Vocabulary.required),
  nr_locuri: Yup.number().required(Vocabulary.required),
  numar_portiere: Yup.number().required(Vocabulary.required),

  // Optional fields
  data_inmatriculare: Yup.mixed()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  kilometri: Yup.mixed().nullable(),
  capacitate_cilindrica: Yup.mixed(),
  putere_cp: Yup.mixed(),
  is_new: Yup.boolean(),
});

export const administrativeSchema = Yup.object().shape({
  user_achizitie_r: Yup.object().required(Vocabulary.required),
  user_logistica_r: Yup.object().required(Vocabulary.required),
  tip_achizitie_r: Yup.object().required(Vocabulary.required),
  firma_achizitie_r: Yup.object().required(Vocabulary.required),
  furnizor_r: Yup.object().required(Vocabulary.required),
  locatie_administrativa_r: Yup.object().required(Vocabulary.required),
  physical_location: Yup.string().nullable(),
  tip_tva_r: Yup.object().required(Vocabulary.required),

  // Conditional validation for user_intermediere
  user_intermediere: Yup.object().when("tip_achizitie_r", {
    is: (val: any) => val?.nume === PurchaseTypes.intemediated,
    then: (schema) => schema.required(Vocabulary.required),
    otherwise: (schema) => schema.nullable(),
  }),

  // Optional fields
  vanzator: Yup.object().nullable(),
  cursEuro: Yup.string(),
  pret_achizitie_euro: Yup.number()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  pret_achizitie_ron: Yup.number()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  pret_vanzare_euro: Yup.number()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  pret_vanzare_ron: Yup.number()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  pret_minim_vanzare: Yup.number()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  bonus_vanzare_vehicul: Yup.number()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr)),

  // Date fields with conditional validation
  data_achizitie: Yup.date()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .typeError(Vocabulary.invalidDate),

  data_receptie: Yup.date()
    .nullable()
    .when("tip_achizitie_r", {
      is: (val: any) =>
        val?.nume === PurchaseTypes.buyBack ||
        val?.nume === PurchaseTypes.national ||
        val?.nume === PurchaseTypes.intemediated,
      then: (schema) => schema.typeError(Vocabulary.invalidDate),
      otherwise: (schema) => schema.typeError(Vocabulary.invalidDate),
    }),

  // Vehicle characteristics
  retromobil: Yup.string(),
  carte_service: Yup.string(),
  tuning: Yup.string(),
  volan: Yup.string(),
});
